@if (useDefaultImage() || image()) {
  <div class="photo-preview-wrapper">
    @if (!dragdrop()) {
      <img
        nz-image
        nzDisablePreview
        class="photo-preview take-photo-wrapper clickable"
        [nzSrc]="(useDefaultImage() ? defaultImage() : image()) ?? ''"
        (load)="onImageLoaded($event)"
      />
    }

    @if (dragdrop()) {
      <app-dragdrop-marker-image
        [image]="useDefaultImage() ? defaultImage() : image()"
        [markers]="markers()"
        (imageOnLoad)="onImageLoaded($event)"
      />
    }

    @if (!useDefaultImage() && !dragdrop()) {
      @for (marker of markers(); track marker.id || $index) {
        <div
          class="sensor-marker-wrapper"
          [style.left.px]="
            marker.getClientX(
              clientWidth(),
              clientHeight(),
              imageWidth(),
              imageHeight(),
              30
            )
          "
          [style.top.px]="
            marker.getClientY(
              clientWidth(),
              clientHeight(),
              imageWidth(),
              imageHeight(),
              32
            )
          "
        >
          <div class="sensor-marker" [class.selected]="marker.selected">
            <span [class.smallFont]="(marker?.label?.length ?? 0) > 3">{{
              marker.label
            }}</span>
            <div class="sub-marker body-bold">
              <span [class.smallFont]="(marker?.label?.length ?? 0) > 3">{{
                marker.label
              }}</span>
            </div>
          </div>
        </div>
      }
    }

    @if (!sensorMarkerPlaced() && !useDefaultImage()) {
      <div
        class="backdrop-mark-sensor-on-photo clickable"
        (click)="markImageClicked.emit()"
      ></div>
    }

    @if (useDefaultImage() || sensorMarkerPlaced()) {
      <app-nav-button
        (clickEvent)="
          !useDefaultImage() && markers().length > 0
            ? editImageClicked.emit()
            : addImageClicked.emit()
        "
        [lighttertiary]="true"
        [wide]="false"
        [smol]="true"
        [bodyBold]="true"
        class="photo-preview-changebtn btn-not-wide"
        [svgIcon]="'icons:edit'"
      >
        {{ i18n.langString("edit_photo") }}
      </app-nav-button>
    }

    @if (!useDefaultImage() && !sensorMarkerPlaced()) {
      <app-nav-button
        (clickEvent)="markImageClicked.emit()"
        [darksecondary]="false"
        [lighttertiary]="true"
        [svgIcon]="'icons:location'"
        [wide]="false"
        [smol]="true"
        [bodyBold]="true"
        class="photo-preview-markbtn btn-not-wide"
      >
        {{ i18n.langString("mark_sensor_on_photo") }}
      </app-nav-button>
    }
  </div>
}

@if (!image() && !useDefaultImage()) {
  <div (click)="addImageClicked.emit()" class="take-photo-wrapper clickable">
    <i
      nz-icon
      nzType="icons:camera"
      class="svg-icon"
      style="font-size: 70px"
    ></i>
    <span class="body-bold take-photo-text">{{ photoLabel() }}</span>
    <span>{{ i18n.langString("photo_format") }}</span>
    <span>{{ i18n.langString("photo_size") }}</span>
  </div>
}

<div
  [style]="
    isMobile()
      ? 'display: flex; justify-content: center; margin-bottom: 8px;'
      : 'display: flex; justify-content: left; width: 100%;'
  "
>
  @if (!useDefaultImage() && !isRotatingEquipment()) {
    <app-nav-button
      [darksecondary]="true"
      [bodyBold]="true"
      [wide]="false"
      [svgIcon]="'icons:image'"
      (clickEvent)="useDefaultImageClicked.emit()"
      style="align-self: center"
    >
      {{ i18n.langString("use_as_default") }}
    </app-nav-button>
  }

  @if (!useDefaultImage() && isRotatingEquipment()) {
    <app-nav-button
      [darksecondary]="true"
      [wide]="!isMobile()"
      [bodyBold]="true"
      [svgIcon]="'icons:image'"
      class="question-btn"
      (clickEvent)="showPhotoSelectionPopup.set(true)"
    >
      {{ i18n.langString("select_a_photo") }}
    </app-nav-button>
  }
</div>

@if (showPhotoSelectionPopup()) {
  <app-select-photo-popup
    [header]="i18n.langString('rotatingeq_photo_selection_title')"
    [instructions]="rotatingEq_itemDetails"
    (close)="showPhotoSelectionPopup.set(false)"
    (save)="saveSelectedPhoto($event)"
  />
}
